export default __webpack_public_path__ + "static/media/saveIcon.f87230e8.svg";